@if (showToggleAll && groupedIssues.length > 0) {
  <div class="toggle-all-row">
    <a class="toggle-all-btn" href="javascript:void(0)" role="button" (click)="toggleAll()">
      @if (allExpanded) {
        <svg lucideChevronsUp></svg>
      } @else {
        <svg lucideChevronsDown></svg>
      }
      {{ allExpanded ? 'Collapse All' : 'Expand All' }}
    </a>
  </div>
}
@for (group of groupedIssues; track trackByGroup($index, group)) {
  <div class="issue-group">
    <!-- Single-issue group: render as content group (no parent accordion needed) -->
    @if (group.issues.length === 1) {
      <issue-content-group
        [subGroup]="group.contentSubGroups[0]"
        [sync-pair]="syncPair"
        [application]="application"
        (resourceClicked)="resourceClicked.emit($event)"
      ></issue-content-group>
    } @else {
      <!-- Header and body are wrapped together so one elevated surface covers the whole group,
      open or closed. -->
      <div class="group-card">
        <button class="group-header" (click)="toggleGroup(group)" [class.expanded]="group.expanded">
          <div class="group-title">
            <span class="group-name">{{ group.displayName }}</span>
            <span class="group-count">{{ group.issues.length }}</span>
          </div>
          <div class="group-end">
            @if (group.resourceTypesLabel) {
              <span class="group-resource-types">{{ group.resourceTypesLabel }}</span>
            }
            @if (group.expanded) {
              <svg lucideChevronUp class="group-chevron"></svg>
            } @else {
              <svg lucideChevronDown class="group-chevron"></svg>
            }
          </div>
        </button>
        <div class="group-body" [@accordionSlide]="group.expanded ? 'expanded' : 'collapsed'">
          @for (subGroup of group.contentSubGroups; track trackBySubGroup($index, subGroup)) {
            <issue-content-group
              [subGroup]="subGroup"
              [sync-pair]="syncPair"
              [application]="application"
              [flat]="group.contentSubGroups.length === 1"
              [grouped]="true"
              (resourceClicked)="resourceClicked.emit($event)"
            ></issue-content-group>
          }
        </div>
      </div>
    }
    <!-- Multi-issue group: parent accordion with children -->
  </div>
}
